import Button from "../../../Components/Common/Button/Button";
// import SectionHeader from "../GcProjectDetails/components/SectionHeader";
import { useEffect } from "react";
import { useGcLayout } from "../GcLayout";
import useScrollToTop from "../../../hooks/useScrollToTop";

interface SubmitConfirmationProps {
  docDone: number;
  docNA: number;
  qaAnswered: number;
  totalQA: number;
  projectData?: any;
  projectType?: string;
  localStorgeUserData?: string;
  onBackToDashboard: () => void;
}

const SubmitConfirmation = ({
  docDone,
  docNA,
  qaAnswered,
  totalQA,
  localStorgeUserData,
  projectData,
  projectType,
  onBackToDashboard,
}: SubmitConfirmationProps) => {
  const { setCrumbs } = useGcLayout();

  useScrollToTop(0, { skipFirstRender: false });

  useEffect(() => {
    setCrumbs([{ label: "Dashboard", link: "/gc-dashboard" }]);
  }, []);

  const cscAdmin =
    `${projectData?.admin?.firstName ?? ""} ${projectData?.admin?.lastName ?? ""}`.trim() ||
    null;
  const lender = projectData?.lender?.companyName ?? null;
  return (
    <div className="gc-precon-commercial">
      <div className="submit-screen">
        <div className="submit-icon">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
              d="M6 16l7 7 13-13"
              stroke="#1a6b35"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="submit-title">Checklist Submitted</div>
        <div className="submit-sub">
          Your pre-construction documents and responses have been submitted to{" "}
          {cscAdmin ?? "-"} for review. You'll be notified if any additional
          information is needed.
        </div>

        <div className="submit-detail">
          <div className="sd-row">
            <span className="sd-label">Project</span>
            <span className="sd-val">{projectData?.projectName ?? "-"}</span>
          </div>
          <div className="sd-row">
            <span className="sd-label">Project type</span>
            <span className="sd-val" style={{ textTransform: "capitalize" }}>
              {projectType ?? projectData?.projectType ?? "-"}
            </span>
          </div>
          <div className="sd-row">
            <span className="sd-label">Submitted by</span>
            <span className="sd-val">{localStorgeUserData ?? "-"}</span>
          </div>
          <div className="sd-row">
            <span className="sd-label">Submitted to</span>
            <span className="sd-val">{cscAdmin ?? "-"}</span>
          </div>
          <div className="sd-row">
            <span className="sd-label">Lender notified</span>
            <span className="sd-val">{lender ?? "-"}</span>
          </div>
          <div className="sd-row">
            <span className="sd-label">Documents submitted</span>
            <span className="sd-val green">
              {docDone} uploaded, {docNA} marked N/A
            </span>
          </div>
          <div className="sd-row">
            <span className="sd-label">Questions answered</span>
            <span className="sd-val green">
              {qaAnswered} of {totalQA} answered
            </span>
          </div>
          <div className="sd-row">
            <span className="sd-label">Status</span>
            <span className="sd-val" style={{ color: "var(--amber)" }}>
              Pending CSC Review
            </span>
          </div>
        </div>

        <div className="submit-actions">
          <Button className="btn btnSm btnPrimary" onClick={onBackToDashboard}>
            ← Back to Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubmitConfirmation;
